export default "__VITE_ASSET__CiWNrBY5__"